import type { LocationDto } from '@/lib/api';

/**
 * Whether `location` has a display name — a CMS-configured `websiteData.centerName`,
 * or failing that the SH Gateway-imported `name`.
 */
export function hasCenterName(location: LocationDto | undefined): boolean {
  return Boolean(location?.websiteData?.centerName ?? location?.name);
}

/**
 * The location's display name: the CMS-configured `websiteData.centerName`,
 * falling back to the SH Gateway-imported `name`, or `''` when neither is set.
 */
export function resolveCenterName(location: LocationDto | undefined): string {
  return location?.websiteData?.centerName ?? location?.name ?? '';
}
